import profileImage from '../assets/profile.jpg';

function Header() {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 text-gray-800 p-8 border-b border-gray-200">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Profile Image */}
          <div className="flex-shrink-0">
            <img 
              src={profileImage} 
              alt="Nghiem Xuan Hao" 
              className="w-40 h-40 rounded-full object-cover border-4 border-white shadow-lg"
            />
          </div>
          
          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
              Nghiem Xuan Hao
            </h1>
            <p className="text-xl text-blue-600 font-semibold mb-4">
              AI Solutions Architect + Engineer
            </p>
            
            {/* Contact Info */}
            <div className="space-y-2 text-gray-600">
              <div className="flex items-center justify-center md:justify-start gap-2">
                <span>📍</span>
                <span>Hanoi, Vietnam</span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2">
                <span>📧</span>
                <a href="mailto:qtvhao@gmail.com" className="hover:text-blue-600 transition-colors">
                  qtvhao@gmail.com
                </a>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2">
                <span>📱</span>
                <span>(+84) 902132497</span>
              </div>
            </div>
            
            {/* Links */}
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mt-6">
              <a 
                href="https://nghiemxuanhao-fullstackdeveloper.qtvhao.workers.dev" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                View Live Portfolio
              </a>
              <a 
                href="http://linkedin.com/in/haon-x" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 transition-colors font-medium"
              >
                LinkedIn
              </a>
              <a 
                href="http://github.com/qtvhao" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 transition-colors font-medium"
              >
                GitHub
              </a>
            </div>
          </div>
        </div>
        
        {/* Quick Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8 pt-6 border-t border-gray-200">
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600">9+</div>
            <div className="text-sm text-gray-600">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600">60%</div>
            <div className="text-sm text-gray-600">AWS Cost Reduction</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600">92%</div>
            <div className="text-sm text-gray-600">Performance Improvement</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
